<div class="hmf-change-timezone-modal--title">
  {{ 'timezones.modal-title' | translate }}
  <mat-icon svgIcon="close" (click)="closeDialog()"></mat-icon>
</div>

@if (dialogData?.browserTimezone) {
  <div
    class="hmf-change-timezone-modal--description"
    [innerHTML]="
      'timezones.modal-description'
        | translate
          : {
              browserTimezone: resolveTimezoneText(dialogData?.browserTimezone),
              timezone: resolveTimezoneText(dialogData?.timezone),
            }
    "
  ></div>
}

<div class="hmf-change-timezone-modal--content">
  <app-input-autocomplete
    [label]="'timezones.title' | translate"
    [placeholder]="'timezones.modal-select-placeholder' | translate"
    [options]="timezonesList$ | ngrxPush"
    [displayWith]="displayTimezone"
    [minLength]="1"
    [formControl]="timezoneCtrl"
  ></app-input-autocomplete>
</div>

<div class="hmf-change-timezone-modal--actions">
  <app-button [buttonParameters]="configList.buttons.cancel" (click)="closeDialog()">
    {{ 'common.cancel' | translate }}
  </app-button>
  <app-button
    [buttonParameters]="configList.buttons.save"
    [disableState]="!timezoneCtrl.value"
    (click)="saveTimezone()"
  >
    {{ 'common.save' | translate }}
  </app-button>
</div>
